import React from "react";
import { Link } from "react-router-dom";
import { useExpediente } from "@/context/ExpedienteContext";
import { Spinner, Empty } from "@/components/common";
import { lbl, SECTION_LABELS } from "@/constants/labels";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function Pendientes() {
  const { exp } = useExpediente();
  if (!exp) return <div className="flex h-64 items-center justify-center text-vino-700"><Spinner className="h-6 w-6" /></div>;
  const pend = exp.pendientes || [];

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Mis pendientes</h1>
        <p className="mt-1 text-sm text-slate-500">Resuelve lo que falta antes de enviar tu expediente a HUMAN.</p>
      </div>
      {pend.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-xl border border-emerald-200 bg-emerald-50 px-6 py-14 text-center" data-testid="sin-pendientes">
          <CheckCircle2 className="mb-3 h-10 w-10 text-emerald-600" />
          <p className="text-base font-semibold text-emerald-800">¡Todo listo!</p>
          <p className="mt-1 text-sm text-emerald-700">No tienes pendientes. Ya puedes revisar y enviar tu expediente.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="lista-pendientes">
          {pend.map((p, i) => (
            <div key={i} className="flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4">
              <AlertCircle className="h-5 w-5 shrink-0 text-amber-600" />
              <div className="flex-1">
                <p className="text-sm font-medium text-slate-800">{p.detalle}</p>
                {p.seccion && <p className="text-xs text-slate-500">Sección: {SECTION_LABELS[p.seccion] || p.seccion}</p>}
              </div>
              <Link to={p.tipo === "beneficiarios" ? "/beneficiarios" : "/hoja-vida"} className="rounded-lg bg-vino-700 px-3 py-1.5 text-xs font-semibold text-white hover:bg-vino-800">Completar</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
